import {
  Box,
  Flex,
  Icon,
  Link,
  Radio,
  RadioGroup,
  Space,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Stack,
  Text,
  TextLabel,
  useColorMode,
  useColorStyle,
  Input,
} from '@tonic-one/react';

import {
  CheckCircleOIcon,
  CircleOIcon,
  ErrorIcon,
  InfoIcon,
  SpinnerIcon,
  SuccessIcon,
} from '@tonic-one/react-icons';

import {
  forwardRef,
  memo,
  useImperativeHandle,
  useRef,
  useState,
  useCallback,
} from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useOrgStore } from '@Models/useOrgModel';
import { EnabledPolicyTypeEnum, PaymentModel } from '@Types/provision';
import { CAS_DOC_LINK, getCasOLHLink } from '@Utils/casDocLink';
import i18next from 'i18next';
import LoadingBtn from '@Components/Common/LoadingBtn';
import { Service } from '@Types/app';

export const StepIcon = ({ checked }: { checked: boolean }) => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  return checked ? (
    <Icon as={CheckCircleOIcon} size="24px" color={colorStyle.color.primary} />
  ) : (
    <Icon as={CircleOIcon} size="24px" color={colorStyle.color.secondary} />
  );
};

export const GoogleLoginSvg = ({ disabled }: { disabled: boolean }) => {
  if (disabled) {
    return (
      <svg
        width="169"
        height="42"
        viewBox="0 0 169 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="btn_google_signin_light_disabled_web">
          <rect width="169" height="42" fill="white" />
          <g id="button">
            <path
              id="button bg"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M6 4C4.89543 4 4 4.89543 4 6V37C4 38.1046 4.89543 39 6 39H164C165.105 39 166 38.1046 166 37V6C166 4.89543 165.105 4 164 4H6Z"
              fill="black"
              fillOpacity="0.08"
            />
          </g>
          <path
            id="Sign in with Google"
            d="M52.7248 22.7656C52.7248 22.3825 52.5892 22.0872 52.3178 21.8797C52.0504 21.6721 51.5656 21.4626 50.8632 21.2511C50.1609 21.0396 49.6022 20.8042 49.1872 20.5448C48.3931 20.046 47.996 19.3955 47.996 18.5934C47.996 17.8911 48.2813 17.3124 48.852 16.8575C49.4266 16.4026 50.1709 16.1751 51.0847 16.1751C51.6913 16.1751 52.232 16.2869 52.7069 16.5103C53.1818 16.7338 53.5549 17.053 53.8263 17.4681C54.0976 17.8791 54.2333 18.336 54.2333 18.8388H52.7248C52.7248 18.3839 52.5812 18.0287 52.2939 17.7733C52.0105 17.514 51.6035 17.3843 51.0727 17.3843C50.5779 17.3843 50.1928 17.49 49.9175 17.7015C49.6461 17.913 49.5104 18.2083 49.5104 18.5874C49.5104 18.9067 49.6581 19.174 49.9534 19.3895C50.2487 19.601 50.7355 19.8085 51.4139 20.0121C52.0923 20.2116 52.6371 20.4411 53.0481 20.7004C53.4591 20.9558 53.7604 21.2511 53.952 21.5863C54.1435 21.9176 54.2393 22.3066 54.2393 22.7536C54.2393 23.4799 53.9599 24.0585 53.4013 24.4895C52.8466 24.9165 52.0923 25.13 51.1386 25.13C50.5081 25.13 49.9275 25.0143 49.3967 24.7828C48.8699 24.5474 48.4589 24.2241 48.1636 23.8131C47.8723 23.4021 47.7266 22.9232 47.7266 22.3765H49.2411C49.2411 22.8713 49.4047 23.2544 49.7319 23.5258C50.0591 23.7971 50.528 23.9328 51.1386 23.9328C51.6654 23.9328 52.0604 23.8271 52.3238 23.6156C52.5912 23.4001 52.7248 23.1167 52.7248 22.7656ZM57.1664 25.0103H55.7118V18.5336H57.1664V25.0103ZM55.622 16.8515C55.622 16.6281 55.6918 16.4425 55.8315 16.2948C55.9752 16.1472 56.1787 16.0734 56.4421 16.0734C56.7055 16.0734 56.909 16.1472 57.0526 16.2948C57.1963 16.4425 57.2681 16.6281 57.2681 16.8515C57.2681 17.071 57.1963 17.2546 57.0526 17.4022C56.909 17.5459 56.7055 17.6177 56.4421 17.6177C56.1787 17.6177 55.9752 17.5459 55.8315 17.4022C55.6918 17.2546 55.622 17.071 55.622 16.8515ZM58.6928 21.724C58.6928 20.7184 58.9282 19.9163 59.3991 19.3177C59.874 18.7151 60.5025 18.4138 61.2846 18.4138C62.0229 18.4138 62.6035 18.6712 63.0265 19.186L63.0924 18.5336H64.4033V24.8127C64.4033 25.6627 64.1379 26.3331 63.6072 26.824C63.0804 27.3148 62.3681 27.5603 61.4702 27.5603C60.9953 27.5603 60.5304 27.4605 60.0755 27.261C59.6246 27.0654 59.2814 26.808 59.0459 26.4888L59.7343 25.6148C60.1813 26.1456 60.732 26.411 61.3864 26.411C61.8693 26.411 62.2504 26.2793 62.5297 26.0159C62.8091 25.7565 62.9487 25.3734 62.9487 24.8666V24.4296C62.5297 24.8965 61.971 25.13 61.2727 25.13C60.5145 25.13 59.8939 24.8287 59.4111 24.2261C58.9322 23.6235 58.6928 22.7895 58.6928 21.724ZM60.1413 21.8497C60.1413 22.5002 60.273 23.013 60.5364 23.3881C60.8038 23.7592 61.1729 23.9448 61.6438 23.9448C62.2304 23.9448 62.6654 23.6934 62.9487 23.1906V20.3413C62.6734 19.8504 62.2424 19.605 61.6558 19.605C61.1769 19.605 60.8038 19.7946 60.5364 20.1737C60.273 20.5528 60.1413 21.1115 60.1413 21.8497ZM67.4441 18.5336L67.486 19.2818C67.9649 18.7032 68.5934 18.4138 69.3716 18.4138C70.7204 18.4138 71.4068 19.186 71.4307 20.7304V25.0103H69.9761V20.8142C69.9761 20.4031 69.8863 20.0999 69.7068 19.9043C69.5312 19.7048 69.2419 19.605 68.8388 19.605C68.2522 19.605 67.8152 19.8704 67.5279 20.4011V25.0103H66.0733V18.5336H67.4441ZM77.9014 25.0103H76.4469V18.5336H77.9014V25.0103ZM76.3571 16.8515C76.3571 16.6281 76.4269 16.4425 76.5666 16.2948C76.7102 16.1472 76.9138 16.0734 77.1771 16.0734C77.4405 16.0734 77.644 16.1472 77.7877 16.2948C77.9314 16.4425 78.0032 16.6281 78.0032 16.8515C78.0032 17.071 77.9314 17.2546 77.7877 17.4022C77.644 17.5459 77.4405 17.6177 77.1771 17.6177C76.9138 17.6177 76.7102 17.5459 76.5666 17.4022C76.4269 17.2546 76.3571 17.071 76.3571 16.8515ZM81.032 18.5336L81.0739 19.2818C81.5528 18.7032 82.1813 18.4138 82.9595 18.4138C84.3083 18.4138 84.9947 19.186 85.0186 20.7304V25.0103H83.5641V20.8142C83.5641 20.4031 83.4743 20.0999 83.2947 19.9043C83.1191 19.7048 82.8298 19.605 82.4268 19.605C81.8401 19.605 81.4032 19.8704 81.1158 20.4011V25.0103H79.6613V18.5336H81.032ZM95.6316 23.005L96.6612 18.5336H98.0798L96.314 25.0103H95.1168L93.7281 20.5628L92.3633 25.0103H91.1661L89.3943 18.5336H90.813L91.8605 22.9571L93.1894 18.5336H94.2848L95.6316 23.005ZM100.791 25.0103H99.3368V18.5336H100.791V25.0103ZM99.2471 16.8515C99.2471 16.6281 99.3169 16.4425 99.4566 16.2948C99.6002 16.1472 99.8037 16.0734 100.067 16.0734C100.33 16.0734 100.534 16.1472 100.678 16.2948C100.821 16.4425 100.893 16.6281 100.893 16.8515C100.893 17.071 100.821 17.2546 100.678 17.4022C100.534 17.5459 100.33 17.6177 100.067 17.6177C99.8037 17.6177 99.6002 17.5459 99.4566 17.4022C99.3169 17.2546 99.2471 17.071 99.2471 16.8515ZM104.395 16.9593V18.5336H105.538V19.611H104.395V23.2265C104.395 23.4739 104.443 23.6535 104.539 23.7652C104.638 23.873 104.814 23.9268 105.065 23.9268C105.233 23.9268 105.403 23.9069 105.574 23.867V24.9923C105.243 25.0841 104.924 25.13 104.616 25.13C103.499 25.13 102.94 24.5134 102.94 23.2804V19.611H101.875V18.5336H102.94V16.9593H104.395ZM108.28 19.2399C108.755 18.6892 109.355 18.4138 110.081 18.4138C111.462 18.4138 112.163 19.202 112.183 20.7783V25.0103H110.728V20.8321C110.728 20.3852 110.63 20.0699 110.435 19.8864C110.243 19.6988 109.96 19.605 109.585 19.605C109.002 19.605 108.567 19.8644 108.28 20.3832V25.0103H106.825V15.816H108.28V19.2399ZM123.915 23.8789C123.6 24.29 123.163 24.6012 122.604 24.8127C122.045 25.0242 121.411 25.13 120.7 25.13C119.97 25.13 119.324 24.9644 118.761 24.6332C118.198 24.3019 117.763 23.8291 117.456 23.2145C117.153 22.596 116.995 21.8757 116.983 21.0536V20.3712C116.983 19.0543 117.298 18.0268 117.929 17.2885C118.559 16.5462 119.439 16.1751 120.569 16.1751C121.538 16.1751 122.309 16.4146 122.879 16.8934C123.45 17.3723 123.793 18.0627 123.909 18.9645H122.424C122.257 17.915 121.648 17.3903 120.599 17.3903C119.92 17.3903 119.403 17.6357 119.048 18.1265C118.697 18.6134 118.516 19.3297 118.504 20.2754V20.9459C118.504 21.8876 118.701 22.6199 119.096 23.1427C119.495 23.6615 120.048 23.9208 120.754 23.9208C121.528 23.9208 122.079 23.7453 122.406 23.3941V21.6881H120.611V20.5388H123.915V23.8789ZM125.357 21.7121C125.357 21.0776 125.483 20.5069 125.735 20.0001C125.986 19.4893 126.339 19.0982 126.794 18.8269C127.249 18.5515 127.772 18.4138 128.362 18.4138C129.236 18.4138 129.945 18.6952 130.487 19.2578C131.034 19.8205 131.329 20.5668 131.373 21.4966L131.379 21.8378C131.379 22.4762 131.256 23.0469 131.008 23.5497C130.765 24.0525 130.413 24.4416 129.955 24.717C129.5 24.9923 128.973 25.13 128.374 25.13C127.46 25.13 126.728 24.8267 126.177 24.2201C125.631 23.6096 125.357 22.7975 125.357 21.7839V21.7121ZM126.812 21.8378C126.812 22.5042 126.95 23.0269 127.225 23.4061C127.5 23.7812 127.883 23.9687 128.374 23.9687C128.865 23.9687 129.246 23.7772 129.518 23.3941C129.793 23.011 129.931 22.4503 129.931 21.7121C129.931 21.0576 129.789 20.5388 129.506 20.1557C129.226 19.7726 128.845 19.5811 128.362 19.5811C127.887 19.5811 127.51 19.7706 127.231 20.1497C126.952 20.5249 126.812 21.0875 126.812 21.8378ZM132.529 21.7121C132.529 21.0776 132.654 20.5069 132.906 20.0001C133.157 19.4893 133.51 19.0982 133.965 18.8269C134.42 18.5515 134.943 18.4138 135.533 18.4138C136.407 18.4138 137.116 18.6952 137.658 19.2578C138.205 19.8205 138.5 20.5668 138.544 21.4966L138.55 21.8378C138.55 22.4762 138.427 23.0469 138.179 23.5497C137.936 24.0525 137.585 24.4416 137.126 24.717C136.671 24.9923 136.144 25.13 135.545 25.13C134.632 25.13 133.899 24.8267 133.349 24.2201C132.802 23.6096 132.529 22.7975 132.529 21.7839V21.7121ZM133.983 21.8378C133.983 22.5042 134.121 23.0269 134.396 23.4061C134.671 23.7812 135.055 23.9687 135.545 23.9687C136.036 23.9687 136.417 23.7772 136.689 23.3941C136.964 23.011 137.102 22.4503 137.102 21.7121C137.102 21.0576 136.96 20.5388 136.677 20.1557C136.397 19.7726 136.016 19.5811 135.533 19.5811C135.059 19.5811 134.681 19.7706 134.402 20.1497C134.123 20.5249 133.983 21.0875 133.983 21.8378ZM139.718 21.724C139.718 20.7184 139.953 19.9163 140.424 19.3177C140.899 18.7151 141.527 18.4138 142.309 18.4138C143.048 18.4138 143.628 18.6712 144.051 19.186L144.117 18.5336H145.428V24.8127C145.428 25.6627 145.163 26.3331 144.632 26.824C144.105 27.3148 143.393 27.5603 142.495 27.5603C142.02 27.5603 141.555 27.4605 141.1 27.261C140.649 27.0654 140.306 26.808 140.071 26.4888L140.759 25.6148C141.206 26.1456 141.757 26.411 142.411 26.411C142.894 26.411 143.275 26.2793 143.554 26.0159C143.834 25.7565 143.973 25.3734 143.973 24.8666V24.4296C143.554 24.8965 142.996 25.13 142.297 25.13C141.539 25.13 140.919 24.8287 140.436 24.2261C139.957 23.6235 139.718 22.7895 139.718 21.724ZM141.166 21.8497C141.166 22.5002 141.298 23.013 141.561 23.3881C141.829 23.7592 142.198 23.9448 142.669 23.9448C143.255 23.9448 143.69 23.6934 143.973 23.1906V20.3413C143.698 19.8504 143.267 19.605 142.681 19.605C142.202 19.605 141.829 19.7946 141.561 20.1737C141.298 20.5528 141.166 21.1115 141.166 21.8497ZM148.666 25.0103H147.212V15.816H148.666V25.0103ZM153.299 25.13C152.378 25.13 151.629 24.8407 151.055 24.262C150.484 23.6794 150.199 22.9052 150.199 21.9395V21.7599C150.199 21.1135 150.323 20.5368 150.57 20.03C150.821 19.5192 151.173 19.1222 151.623 18.8388C152.074 18.5555 152.577 18.4138 153.132 18.4138C154.014 18.4138 154.694 18.6952 155.173 19.2578C155.656 19.8205 155.897 20.6166 155.897 21.6462V22.2328H151.665C151.709 22.7676 151.887 23.1906 152.198 23.5018C152.513 23.8131 152.908 23.9687 153.383 23.9687C154.05 23.9687 154.592 23.6994 155.011 23.1606L155.796 23.9089C155.536 24.296 155.189 24.5972 154.754 24.8127C154.323 25.0242 153.838 25.13 153.299 25.13ZM153.126 19.5811C152.727 19.5811 152.404 19.7208 152.156 20.0001C151.913 20.2794 151.757 20.6685 151.689 21.1673H154.461V21.0596C154.429 20.5727 154.299 20.2056 154.072 19.9582C153.844 19.7068 153.529 19.5811 153.126 19.5811Z"
            fill="black"
            fillOpacity="0.4"
          />
          <path
            id="Shape Copy"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.0348 22.5117V19.58H28.4113C28.5216 20.0765 28.6083 20.5415 28.6083 21.1956C28.6083 25.6955 25.5899 28.8952 21.0427 28.8952C16.6925 28.8952 13.1619 25.3645 13.1619 21.0143C13.1619 16.6641 16.6925 13.1335 21.0427 13.1335C23.1705 13.1335 24.9516 13.9137 26.315 15.1904L24.0768 17.3655C23.5094 16.8296 22.5164 16.1991 21.0427 16.1991C18.4341 16.1991 16.3063 18.3664 16.3063 21.0222C16.3063 23.678 18.4341 25.8453 21.0427 25.8453C24.0611 25.8453 25.1722 23.7569 25.3771 22.5196H21.0348V22.5117Z"
            fill="black"
            fillOpacity="0.4"
          />
        </g>
      </svg>
    );
  }
  return (
    <svg
      width="166"
      height="40"
      viewBox="0 0 166 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_22482_162)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 2C2.89543 2 2 2.89543 2 4V35C2 36.1046 2.89543 37 4 37H162C163.105 37 164 36.1046 164 35V4C164 2.89543 163.105 2 162 2H4Z"
          fill="#4285F4"
        />
      </g>
      <path
        d="M50.5762 20.8027C50.5762 20.4277 50.4434 20.1387 50.1777 19.9355C49.916 19.7324 49.4414 19.5273 48.7539 19.3203C48.0664 19.1133 47.5195 18.8828 47.1133 18.6289C46.3359 18.1406 45.9473 17.5039 45.9473 16.7188C45.9473 16.0312 46.2266 15.4648 46.7852 15.0195C47.3477 14.5742 48.0762 14.3516 48.9707 14.3516C49.5645 14.3516 50.0938 14.4609 50.5586 14.6797C51.0234 14.8984 51.3887 15.2109 51.6543 15.6172C51.9199 16.0195 52.0527 16.4668 52.0527 16.959H50.5762C50.5762 16.5137 50.4355 16.166 50.1543 15.916C49.877 15.6621 49.4785 15.5352 48.959 15.5352C48.4746 15.5352 48.0977 15.6387 47.8281 15.8457C47.5625 16.0527 47.4297 16.3418 47.4297 16.7129C47.4297 17.0254 47.5742 17.2871 47.8633 17.498C48.1523 17.7051 48.6289 17.9082 49.293 18.1074C49.957 18.3027 50.4902 18.5273 50.8926 18.7812C51.2949 19.0312 51.5898 19.3203 51.7773 19.6484C51.9648 19.9727 52.0586 20.3535 52.0586 20.791C52.0586 21.502 51.7852 22.0684 51.2383 22.4902C50.6953 22.9082 49.957 23.1172 49.0234 23.1172C48.4062 23.1172 47.8379 23.0039 47.3184 22.7773C46.8027 22.5469 46.4004 22.2305 46.1113 21.8281C45.8262 21.4258 45.6836 20.957 45.6836 20.4219H47.166C47.166 20.9062 47.3262 21.2812 47.6465 21.5469C47.9668 21.8125 48.4258 21.9453 49.0234 21.9453C49.5391 21.9453 49.9258 21.8418 50.1836 21.6348C50.4453 21.4238 50.5762 21.1465 50.5762 20.8027ZM54.9277 23H53.5039V16.6602H54.9277V23ZM53.416 15.0137C53.416 14.7949 53.4844 14.6133 53.6211 14.4688C53.7617 14.3242 53.9609 14.252 54.2188 14.252C54.4766 14.252 54.6758 14.3242 54.8164 14.4688C54.957 14.6133 55.0273 14.7949 55.0273 15.0137C55.0273 15.2285 54.957 15.4082 54.8164 15.5527C54.6758 15.6934 54.4766 15.7637 54.2188 15.7637C53.9609 15.7637 53.7617 15.6934 53.6211 15.5527C53.4844 15.4082 53.416 15.2285 53.416 15.0137ZM56.4258 19.7832C56.4258 18.7988 56.6562 18.0137 57.1172 17.4277C57.582 16.8379 58.1973 16.543 58.9629 16.543C59.6855 16.543 60.2539 16.7949 60.668 17.2988L60.7324 16.6602H62.0156V22.8066C62.0156 23.6387 61.7559 24.2949 61.2363 24.7754C60.7207 25.2559 60.0234 25.4961 59.1445 25.4961C58.6797 25.4961 58.2246 25.3984 57.7793 25.2031C57.3379 25.0117 57.002 24.7598 56.7715 24.4473L57.4453 23.5918C57.8828 24.1113 58.4219 24.3711 59.0625 24.3711C59.5352 24.3711 59.9082 24.2422 60.1816 23.9844C60.4551 23.7305 60.5918 23.3555 60.5918 22.8594V22.4316C60.1816 22.8887 59.6348 23.1172 58.9512 23.1172C58.209 23.1172 57.6016 22.8223 57.1289 22.2324C56.6602 21.6426 56.4258 20.8262 56.4258 19.7832ZM57.8438 19.9062C57.8438 20.543 57.9727 21.0449 58.2305 21.4121C58.4922 21.7754 58.8535 21.957 59.3145 21.957C59.8887 21.957 60.3145 21.7109 60.5918 21.2188V18.4297C60.3223 17.9492 59.9004 17.709 59.3262 17.709C58.8574 17.709 58.4922 17.8945 58.2305 18.2656C57.9727 18.6367 57.8438 19.1836 57.8438 19.9062ZM64.9961 16.6602L65.0371 17.3926C65.5059 16.8262 66.1211 16.543 66.8828 16.543C68.2031 16.543 68.875 17.2988 68.8984 18.8105V23H67.4746V18.8926C67.4746 18.4902 67.3867 18.1934 67.2109 18.002C67.0391 17.8066 66.7559 17.709 66.3613 17.709C65.7871 17.709 65.3594 17.9688 65.0781 18.4883V23H63.6543V16.6602H64.9961ZM75.2402 23H73.8164V16.6602H75.2402V23ZM73.7285 15.0137C73.7285 14.7949 73.7969 14.6133 73.9336 14.4688C74.0742 14.3242 74.2734 14.252 74.5312 14.252C74.7891 14.252 74.9883 14.3242 75.1289 14.4688C75.2695 14.6133 75.3398 14.7949 75.3398 15.0137C75.3398 15.2285 75.2695 15.4082 75.1289 15.5527C74.9883 15.6934 74.7891 15.7637 74.5312 15.7637C74.2734 15.7637 74.0742 15.6934 73.9336 15.5527C73.7969 15.4082 73.7285 15.2285 73.7285 15.0137ZM78.3086 16.6602L78.3496 17.3926C78.8184 16.8262 79.4336 16.543 80.1953 16.543C81.5156 16.543 82.1875 17.2988 82.2109 18.8105V23H80.7871V18.8926C80.7871 18.4902 80.6992 18.1934 80.5234 18.002C80.3516 17.8066 80.0684 17.709 79.6738 17.709C79.0996 17.709 78.6719 17.9688 78.3906 18.4883V23H76.9668V16.6602H78.3086ZM92.6074 21.0371L93.6152 16.6602H95.0039L93.2754 23H92.1035L90.7441 18.6465L89.4082 23H88.2363L86.502 16.6602H87.8906L88.916 20.9902L90.2168 16.6602H91.2891L92.6074 21.0371ZM97.6621 23H96.2383V16.6602H97.6621V23ZM96.1504 15.0137C96.1504 14.7949 96.2188 14.6133 96.3555 14.4688C96.4961 14.3242 96.6953 14.252 96.9531 14.252C97.2109 14.252 97.4102 14.3242 97.5508 14.4688C97.6914 14.6133 97.7617 14.7949 97.7617 15.0137C97.7617 15.2285 97.6914 15.4082 97.5508 15.5527C97.4102 15.6934 97.2109 15.7637 96.9531 15.7637C96.6953 15.7637 96.4961 15.6934 96.3555 15.5527C96.2188 15.4082 96.1504 15.2285 96.1504 15.0137ZM101.193 15.1191V16.6602H102.312V17.7148H101.193V21.2539C101.193 21.4961 101.24 21.6719 101.334 21.7812C101.432 21.8867 101.604 21.9395 101.85 21.9395C102.014 21.9395 102.18 21.9199 102.348 21.8809V22.9824C102.023 23.0723 101.711 23.1172 101.41 23.1172C100.316 23.1172 99.7695 22.5137 99.7695 21.3066V17.7148H98.7266V16.6602H99.7695V15.1191H101.193ZM105 17.3516C105.465 16.8125 106.053 16.543 106.764 16.543C108.115 16.543 108.801 17.3145 108.82 18.8574V23H107.396V18.9102C107.396 18.4727 107.301 18.1641 107.109 17.9844C106.922 17.8008 106.645 17.709 106.277 17.709C105.707 17.709 105.281 17.9629 105 18.4707V23H103.576V14H105V17.3516ZM120.312 21.8926C120.004 22.2949 119.576 22.5996 119.029 22.8066C118.482 23.0137 117.861 23.1172 117.166 23.1172C116.451 23.1172 115.818 22.9551 115.268 22.6309C114.717 22.3066 114.291 21.8438 113.99 21.2422C113.693 20.6367 113.539 19.9316 113.527 19.127V18.459C113.527 17.1699 113.836 16.1641 114.453 15.4414C115.07 14.7148 115.932 14.3516 117.037 14.3516C117.986 14.3516 118.74 14.5859 119.299 15.0547C119.857 15.5234 120.193 16.1992 120.307 17.082H118.854C118.689 16.0547 118.094 15.541 117.066 15.541C116.402 15.541 115.896 15.7812 115.549 16.2617C115.205 16.7383 115.027 17.4395 115.016 18.3652V19.0215C115.016 19.9434 115.209 20.6602 115.596 21.1719C115.986 21.6797 116.527 21.9336 117.219 21.9336C117.977 21.9336 118.516 21.7617 118.836 21.418V19.748H117.078V18.623H120.312V21.8926ZM121.729 19.7715C121.729 19.1504 121.852 18.5918 122.098 18.0957C122.344 17.5957 122.689 17.2129 123.135 16.9473C123.58 16.6777 124.092 16.543 124.67 16.543C125.525 16.543 126.219 16.8184 126.75 17.3691C127.285 17.9199 127.574 18.6504 127.617 19.5605L127.623 19.8945C127.623 20.5195 127.502 21.0781 127.26 21.5703C127.021 22.0625 126.678 22.4434 126.229 22.7129C125.783 22.9824 125.268 23.1172 124.682 23.1172C123.787 23.1172 123.07 22.8203 122.531 22.2266C121.996 21.6289 121.729 20.834 121.729 19.8418V19.7715ZM123.152 19.8945C123.152 20.5469 123.287 21.0586 123.557 21.4297C123.826 21.7969 124.201 21.9805 124.682 21.9805C125.162 21.9805 125.535 21.793 125.801 21.418C126.07 21.043 126.205 20.4941 126.205 19.7715C126.205 19.1309 126.066 18.623 125.789 18.248C125.516 17.873 125.143 17.6855 124.67 17.6855C124.205 17.6855 123.836 17.8711 123.562 18.2422C123.289 18.6094 123.152 19.1602 123.152 19.8945ZM128.752 19.7715C128.752 19.1504 128.875 18.5918 129.121 18.0957C129.367 17.5957 129.713 17.2129 130.158 16.9473C130.604 16.6777 131.115 16.543 131.693 16.543C132.549 16.543 133.242 16.8184 133.773 17.3691C134.309 17.9199 134.598 18.6504 134.641 19.5605L134.646 19.8945C134.646 20.5195 134.525 21.0781 134.283 21.5703C134.045 22.0625 133.701 22.4434 133.252 22.7129C132.807 22.9824 132.291 23.1172 131.705 23.1172C130.811 23.1172 130.094 22.8203 129.555 22.2266C129.02 21.6289 128.752 20.834 128.752 19.8418V19.7715ZM130.176 19.8945C130.176 20.5469 130.311 21.0586 130.58 21.4297C130.85 21.7969 131.225 21.9805 131.705 21.9805C132.186 21.9805 132.559 21.793 132.824 21.418C133.094 21.043 133.229 20.4941 133.229 19.7715C133.229 19.1309 133.09 18.623 132.812 18.248C132.539 17.873 132.166 17.6855 131.693 17.6855C131.229 17.6855 130.859 17.8711 130.586 18.2422C130.312 18.6094 130.176 19.1602 130.176 19.8945ZM135.793 19.7832C135.793 18.7988 136.023 18.0137 136.484 17.4277C136.949 16.8379 137.564 16.543 138.33 16.543C139.053 16.543 139.621 16.7949 140.035 17.2988L140.1 16.6602H141.383V22.8066C141.383 23.6387 141.123 24.2949 140.604 24.7754C140.088 25.2559 139.391 25.4961 138.512 25.4961C138.047 25.4961 137.592 25.3984 137.146 25.2031C136.705 25.0117 136.369 24.7598 136.139 24.4473L136.812 23.5918C137.25 24.1113 137.789 24.3711 138.43 24.3711C138.902 24.3711 139.275 24.2422 139.549 23.9844C139.822 23.7305 139.959 23.3555 139.959 22.8594V22.4316C139.549 22.8887 139.002 23.1172 138.318 23.1172C137.576 23.1172 136.969 22.8223 136.496 22.2324C136.027 21.6426 135.793 20.8262 135.793 19.7832ZM137.211 19.9062C137.211 20.543 137.34 21.0449 137.598 21.4121C137.859 21.7754 138.221 21.957 138.682 21.957C139.256 21.957 139.682 21.7109 139.959 21.2188V18.4297C139.689 17.9492 139.268 17.709 138.693 17.709C138.225 17.709 137.859 17.8945 137.598 18.2656C137.34 18.6367 137.211 19.1836 137.211 19.9062ZM144.557 23H143.133V14H144.557V23ZM149.096 23.1172C148.193 23.1172 147.461 22.834 146.898 22.2676C146.34 21.6973 146.061 20.9395 146.061 19.9941V19.8184C146.061 19.1855 146.182 18.6211 146.424 18.125C146.67 17.625 147.014 17.2363 147.455 16.959C147.896 16.6816 148.389 16.543 148.932 16.543C149.795 16.543 150.461 16.8184 150.93 17.3691C151.402 17.9199 151.639 18.6992 151.639 19.707V20.2812H147.496C147.539 20.8047 147.713 21.2188 148.018 21.5234C148.326 21.8281 148.713 21.9805 149.178 21.9805C149.83 21.9805 150.361 21.7168 150.771 21.1895L151.539 21.9219C151.285 22.3008 150.945 22.5957 150.52 22.8066C150.098 23.0137 149.623 23.1172 149.096 23.1172ZM148.926 17.6855C148.535 17.6855 148.219 17.8223 147.977 18.0957C147.738 18.3691 147.586 18.75 147.52 19.2383H150.232V19.1328C150.201 18.6562 150.074 18.2969 149.852 18.0547C149.629 17.8086 149.32 17.6855 148.926 17.6855Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 3C3.44771 3 3 3.44772 3 4V35C3 35.5523 3.44772 36 4 36H35C35.5523 36 36 35.5523 36 35V4C36 3.44771 35.5523 3 35 3H4Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.7 19.6705C26.7 19.1386 26.6523 18.6273 26.5636 18.1364H19.5V21.0375H23.5364C23.3625 21.975 22.8341 22.7693 22.0398 23.3011V25.183H24.4636C25.8818 23.8773 26.7 21.9545 26.7 19.6705Z"
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4999 27C21.5249 27 23.2226 26.3284 24.4635 25.183L22.0397 23.3012C21.3681 23.7512 20.509 24.0171 19.4999 24.0171C17.5465 24.0171 15.8931 22.6977 15.3033 20.925H12.7976V22.8682C14.0317 25.3193 16.5681 27 19.4999 27Z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3034 20.925C15.1534 20.475 15.0682 19.9943 15.0682 19.5C15.0682 19.0057 15.1534 18.525 15.3034 18.075V16.1318H12.7977C12.2898 17.1443 12 18.2898 12 19.5C12 20.7102 12.2898 21.8557 12.7977 22.8682L15.3034 20.925Z"
        fill="#FBBC05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.4999 14.983C20.601 14.983 21.5897 15.3614 22.3669 16.1045L24.5181 13.9534C23.2192 12.7432 21.5215 12 19.4999 12C16.5681 12 14.0317 13.6807 12.7976 16.1318L15.3033 18.075C15.8931 16.3023 17.5465 14.983 19.4999 14.983Z"
        fill="#EA4335"
      />
      <defs>
        <filter
          id="filter0_dd_22482_162"
          x="0.25"
          y="0.25"
          width="165.5"
          height="40.25"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.75" />
          <feGaussianBlur stdDeviation="0.875" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_22482_162"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.875" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_22482_162"
            result="effect2_dropShadow_22482_162"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_22482_162"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export const DataSynced = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation('provision');
  return (
    <Flex align="center" gap="8px">
      <Icon as={SuccessIcon} color={colorStyle.color.success} />
      <Text color={colorStyle.color.tertiary}>
        {t('provision.common.syncedDataSuccessfully')}
      </Text>
    </Flex>
  );
};

export const DataSyncing = ({
  onRefresh,
}: {
  onRefresh: () => Promise<void>;
}) => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation('provision');
  return (
    <Box position="relative">
      <Flex gap="8px">
        <Icon as={SpinnerIcon} size="16px" spin color="blue:60" />
        <Flex direction="column">
          <Text color={colorStyle.color.tertiary}>
            {t('provision.common.syncingData')}
          </Text>
          <Text color={colorStyle.color.tertiary}>
            {t('provision.common.syncingDataTakeTime')}
          </Text>
          <Space height="12px" />
          <Box>
            <LoadingBtn
              onClick={onRefresh}
              variant="secondary"
              borderRadius="2rem"
            >
              {t('provision.button.refreshStatus')}
            </LoadingBtn>
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
};

export const DataSyncFailed = ({
  service,
  onRetry,
}: {
  service: Service;
  onRetry: () => Promise<void>;
}) => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation('provision');
  return (
    <>
      <Flex align="center" gap="8px">
        <Icon as={ErrorIcon} color={colorStyle.color.error} />
        <Text color={colorStyle.color.tertiary}>
          {/* TODO */}
          {/* 需要列举出所有的task失败的原因， 例如： */}
          {/* 这是google的一个task: TASKS.GOOGLEDRIVE_USERS_AND_GROUPS_UPDATED.FAILURE */}
          {/* 这是dropbox的两个task: TASKS.DROPBOX_USERS_AND_GROUPS_UPDATED.FAILURE 和 TASKS.DROPBOX_SHARE_FOLDER_VERIFIED.FAILURE */}
          {t(`provision.service.${service}.error.syncData`)}
        </Text>
      </Flex>
      <Box>
        <LoadingBtn
          color={colorStyle.color.secondary}
          onClick={onRetry}
          variant="secondary"
          borderRadius="2rem"
          border="1px solid #5E5E5E"
        >
          {t('common.action.label.retry')}
        </LoadingBtn>
      </Box>
    </>
  );
};

export const GmailNote = memo(() => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation('provision');
  return (
    <Flex gap="8px" pt="16px">
      <Icon as={InfoIcon} color={colorStyle.color.info} />
      <Text fontSize="semibold">{t('common.label.note')}:</Text>
      <Text>
        <Trans i18nKey={'provision.service.gmail.note'} ns="provision">
          placeholder
          <Link
            display="inline"
            href="https://developers.google.com/terms/api-services-user-data-policy"
            target="_blank"
          >
            placeholder
          </Link>
          placeholder
        </Trans>
      </Text>
    </Flex>
  );
});

export const ProvisionOrgInfo = ({ orgId }: { orgId: string }) => {
  const { orgsMap } = useOrgStore();
  const { t } = useTranslation('provision');
  return (
    <Flex paddingBottom="16px" gap="1x">
      <TextLabel>{t('common.label.currentOrganization')}: </TextLabel>
      {orgsMap.get(orgId)}
    </Flex>
  );
};

export const UserIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#424242" />
      <path
        d="M11 14V18H6.21875C5.20833 18 4.56771 17.8125 4.29688 17.4375C4.01562 17.0625 3.9375 16.6198 4.0625 16.1094C4.1875 15.599 4.4375 15.0833 4.8125 14.5625C5.17708 14.0312 5.5 13.6198 5.78125 13.3281C6.28125 12.8281 6.83854 12.3958 7.45312 12.0312C8.07812 11.6667 8.73958 11.3906 9.4375 11.2031L9.5 11.1875V10.6562C8.90625 10.3646 8.42188 9.9375 8.04688 9.375C7.68229 8.8125 7.5 8.18229 7.5 7.48438C7.5 7.00521 7.59375 6.55208 7.78125 6.125C7.95833 5.69792 8.20312 5.32812 8.51562 5.01562C8.83854 4.69271 9.21354 4.44271 9.64062 4.26562C10.0677 4.07812 10.5208 3.98438 11 3.98438C11.4792 3.98438 11.9323 4.07812 12.3594 4.26562C12.7865 4.44271 13.1562 4.69271 13.4688 5.01562C13.7917 5.32812 14.0417 5.69792 14.2188 6.125C14.4062 6.55208 14.5 7.00521 14.5 7.48438C14.5 8.18229 14.3177 8.8125 13.9531 9.375C13.5885 9.9375 13.1094 10.3594 12.5156 10.6406L12.5 10.6562V11.1875C12.7812 11.2604 13.0469 11.349 13.2969 11.4531C13.5573 11.5469 13.8073 11.6562 14.0469 11.7812L14 11.7656V14H11ZM17 15V12H15V15H12V17H15V20H17V17H20V15H17Z"
        fill="white"
        fillOpacity="0.92"
      />
    </svg>
  );
};

export const EnablePolicyRadioGroup = forwardRef(
  ({ service }: { service: Service }, ref) => {
    const [colorMode] = useColorMode();
    const [colorStyle] = useColorStyle({ colorMode });
    const { t } = useTranslation('provision');
    const [enabledPolicyType, setEnabledPolicyType] =
      useState<EnabledPolicyTypeEnum>(EnabledPolicyTypeEnum.Default);
    useImperativeHandle(ref, (): {
      enabledPolicyType: EnabledPolicyTypeEnum;
    } => {
      return {
        enabledPolicyType,
      };
    }, [enabledPolicyType]);
    let accountType = '';
    switch (service) {
      case Service.Gmail:
      case Service.Exchange:
      case Service.GmailInline:
      case Service.ExchangeInline:
        accountType = 'mail';
        break;
      case Service.Teams:
        accountType = 'teams';
        break;
      case Service.SharePoint:
        accountType = 'sharePoint';
        break;
      default:
        accountType = 'other';
    }
    return (
      <RadioGroup
        value={enabledPolicyType}
        onChange={(value: EnabledPolicyTypeEnum) => setEnabledPolicyType(value)}
      >
        <Stack spacing="2x" shouldWrapChildren mx="4px">
          <Radio
            value={EnabledPolicyTypeEnum.Default}
            color={colorStyle.color.primary}
          >
            {t('provision.enablePolicy.defaultAtp.title')}
          </Radio>
          <Text paddingLeft="24px" color={colorStyle.color.tertiary}>
            {t(`provision.enablePolicy.defaultAtp.${accountType}.desc`)}
          </Text>

          <Radio
            value={EnabledPolicyTypeEnum.DefaultMonitor}
            color={colorStyle.color.primary}
          >
            {t('provision.enablePolicy.defaultAtpOnlyMonitor.title')}
          </Radio>
          <Text paddingLeft="24px" color={colorStyle.color.tertiary}>
            {t(
              `provision.enablePolicy.defaultAtpOnlyMonitor.${accountType}.desc`
            )}
          </Text>

          <Radio
            value={EnabledPolicyTypeEnum.None}
            color={colorStyle.color.primary}
          >
            {t('provision.enablePolicy.noPolicy.title')}
          </Radio>
          <Text paddingLeft="24px" color={colorStyle.color.tertiary}>
            {t('provision.enablePolicy.noPolicy.desc')}
          </Text>
        </Stack>
      </RadioGroup>
    );
  }
);

export const ExchangeInlineLearnMore = memo(() => {
  return (
    <Text px="24px" pb="24px">
      <Trans
        i18nKey="provision.service.exchangeInline.learnMore"
        ns="provision"
      >
        placeholder
        <Link
          target="_blank"
          href={getCasOLHLink(
            CAS_DOC_LINK.provision.exchangeInline.learnMore,
            i18next.language
          )}
        >
          placeholder
        </Link>
      </Trans>
    </Text>
  );
});

export const AppInfoForm = forwardRef(
  ({ appId = '' }: { appId?: string }, ref) => {
    const { t } = useTranslation('provision');
    const [formData, setFormData] = useState({
      appId,
      appSecret: '',
      paymentModel: PaymentModel.Evaluation,
    });
    const [formErr, setFormErr] = useState({
      appId: false,
      appSecret: false,
    });
    const textRef = useRef<any>(null);

    const resetFormErr = useCallback(() => {
      setFormErr({
        appId: false,
        appSecret: false,
      });
    }, []);
    const textLabelStyle = {
      p: '12px 0px 4px 0px',
      __after: { content: '"*"', color: '#f24c4f' },
    };

    useImperativeHandle(ref, () => {
      return {
        getData() {
          if (formData.appId === '' || formData.appSecret === '') {
            setFormErr({
              appId: formData.appId === '',
              appSecret: formData.appSecret === '',
            });
            textRef.current?.scrollIntoView();
            throw new Error('form error');
          }
          return formData;
        },
      };
    }, [formData]);

    return (
      <Flex direction="column">
        <TextLabel {...textLabelStyle} ref={textRef}>
          {t('provision.service.teamsChat.appId')}:
        </TextLabel>
        <Input
          placeholder={t('provision.service.teamsChat.appId')}
          width="304px"
          onChange={(e: any) => {
            resetFormErr();
            setFormData({
              ...formData,
              appId: e.target.value,
            });
          }}
          error={formErr.appId}
          value={formData.appId}
        />
        <TextLabel {...textLabelStyle}>
          {t('provision.service.teamsChat.appSecret')}:
        </TextLabel>
        <Input
          type="password"
          placeholder={t('provision.service.teamsChat.appSecret')}
          width="304px"
          onChange={(e: any) => {
            resetFormErr();
            setFormData({
              ...formData,
              appSecret: e.target.value,
            });
          }}
          error={formErr.appSecret}
          value={formData.appSecret}
        />
        <TextLabel {...textLabelStyle}>
          {t('provision.service.teamsChat.selectLicenseModel')}:
        </TextLabel>
        <Menu width="304px">
          <MenuButton variant="secondary" width="100%">
            <Text>
              {t(
                `provision.service.teamsChat.model.${formData.paymentModel}.name`
              )}
            </Text>
          </MenuButton>
          <MenuList width="100%">
            {[
              PaymentModel.ModelA,
              PaymentModel.ModelB,
              PaymentModel.Evaluation,
            ].map((model) => (
              <MenuItem
                key={model}
                onClick={() => {
                  setFormData({
                    ...formData,
                    paymentModel: model,
                  });
                }}
              >
                {t(`provision.service.teamsChat.model.${model}.name`)}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
        <TextLabel>
          {t(`provision.service.teamsChat.model.${formData.paymentModel}.note`)}
        </TextLabel>
      </Flex>
    );
  }
);
